import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faComputer, faCodeBranch, faLaptopCode } from "@fortawesome/free-solid-svg-icons";

import './MyServices.css';

const MyServices = () => {
    return (
        <div className='MyServices'>
            <Container>
                <div className='services-dot'>
                    <h2>SERVICES</h2>
                    <h3>.</h3>
                </div>
                 <p className='serv-p'>How I can help your next project</p>
                <Row>
                    <Col lg={4} md={4} sm={12}>
                        <div className='services my-5 p-4'>
                            <FontAwesomeIcon icon={faComputer} className='serv-icon'/>
                            <h3>Frontend Development</h3>
                            <p>Providing the service of building a fully responsive frontend website with the touch of modern design</p>
                            <a href="/contact"><button>HIRE ME</button></a>
                        </div>
                    </Col>
                    <Col lg={4} md={4} sm={12}>
                        <div className='services my-5 p-4'>
                            <FontAwesomeIcon icon={faCodeBranch} className='serv-icon'/>
                            <h3>MERN-stack Development</h3>
                            <p>Providing the service of building the fully functional MERN-based website with the touch of modern design and functionality</p>
                            <a href="/contact"><button>HIRE ME</button></a>
                        </div>
                    </Col>
                    <Col lg={4} md={4} sm={12}>
                        <div className='services my-5 p-4'>
                            <FontAwesomeIcon icon={faLaptopCode} className='serv-icon'/>
                            <h3>UI/UX Design</h3>
                            <p>Providing the service of the latest and stylish web or mobile user interface design. Hire me to get the best touch for your website</p>
                            <a href="/contact"><button>HIRE ME</button></a>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default MyServices;